$(function(){
    customFields();
    cartInput();
    cart();
    orderlist();
    setDashboard();
    minQty();
});

function customFields(){
    $('[data-product-custom]').on('click', function(){
        $('#modal-custom').toggleClass('active');
    });

    var form = new validateForm($('#modal-custom'), {})
    form.setOptions({
        sendingMsg: 'Salvo le informazioni...',
        successMsg: 'Ok, aggiunto!',
        onSubmit: function(data){
            Swal.fire({
                text: this.sendingMsg,
                showConfirmButton: false,
            });
            var productForm = new validateForm($('[data-type="add-to-cart-form"]'), {});
            productForm.init();
            form.formData = productForm.getData(new FormData());
            form.formData = form.getData(form.formData);
            form.submitForm();
        },
        onSuccessAlertClose: function (data) {
            location.reload();
        }
    });
    form.init();
}

function cart(){
    if($('#cart').length){
        var cartForm = new validateForm($('#cart'), {
            sendingMsg: "Attendere...",
            onSubmit: function () {
                $('#cart').trigger('submit');
            },
        }).init();
    }
}

function orderlist(){
    var ordersTable = '#orders-table';
    if($(ordersTable).length){
        initOrders();
    }

    function initOrders(){
        var orders = [];
        var content;
        var offset = 0;
        var tot = 0;
        var num = 10;

        renderTable();
        checkOrder();

        function renderTable(){
            $(ordersTable).html(table);
            content = $(ordersTable).find('[data-orders-table]');
            getOrders(showOrders);
        }

        function getOrders(callback){
            orders = [];
            var json = {
                "Total": 33,
                "Elements": [
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    }
                ]
            };
            tot = json.Total;
            offset = offset + json.Elements.length;
            orders = json.Elements;
            callback();
        }

        function showOrders(){
            var rows = [];
            $(orders).each(function(i){
                var temp = row.replaceAll('{index}', i)
                                .replaceAll('{total}', getPrice(this.Value))
                                .replaceAll('{purchased_location}', this.ChannelId)
                                .replaceAll('{fulfillment_status}', getFulfillment(this.FulfillmentStatus))
                                .replaceAll('{financial_status}', getPayment(this.InvoiceStatus))
                                .replaceAll('{date}', this.RegistrationDate)
                                .replaceAll('{name}', this.CustomerOrderReference);
                rows.push(temp);
            });
            $(content).append(rows.join(''));
            if(offset < tot){
                $(ordersTable).find('[data-orders-pagination-container]').html(pagination);
                $(ordersTable).find('[data-orders-pagination]').on('click', function(){
                    getOrders(showOrders);
                });
            } else {
                $(ordersTable).find('[data-orders-pagination-container]').html('');
            }
            $(ordersTable).find('[data-order]').on('click', function(){
                var id = $(this).attr('data-order');
                openOrder(id);
            });
        }

        function openOrder(id){
            const params = new URLSearchParams(window.location.search);
            params.set('CustomerOrderReference', id);
            window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            getOrder(id);
        }

        function getOrder(id){
            var order = { 
                "Header" : {
                    "VendorOrderId": "OC/2023/3333",
                    "JLROrderReference": "XXXXXX",
                    "CustomerOrderReference": "CL/2023/56787",
                    "IsExternal": true,
                    "ChannelId": "AGENCY",
                    "CustomerId": "1703",
                    "CustomerAddressId": "8703",
                    "RegistrationDate": "2023-03-27",
                    "InvoiceStatus": "P",
                    "FulfillmentStatus": "Y",
                    "Value": 323456.13,
                    "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                },
                "Lines": [
                    {
                        "LineId": 1,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "KSE123456",
                        "Quantity": 23,
                        "Uom": null,
                        "UnitPrice": 10.45,
                        "DeliveredQuantity": 23,
                        "InvoicedQuantity": 23,
                        "IsClosed": true
                    },
                    {
                        "LineId": 2,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "TGE AD345667",
                        "Quantity": 55,
                        "Uom": null,
                        "UnitPrice": 3.42,
                        "DeliveredQuantity": 55,
                        "InvoicedQuantity": 50,
                        "IsClosed": false
                    },
                    {
                        "LineId": 3,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "WER AAC78900",
                        "Quantity": 150,
                        "Uom": null,
                        "UnitPrice": 5.67,
                        "DeliveredQuantity": 100,
                        "InvoicedQuantity": 100,
                        "IsClosed": true
                    },
                    {
                        "LineId": 4,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "QUE AA68780",
                        "Quantity": 200,
                        "Uom": null,
                        "UnitPrice": 1.78,
                        "DeliveredQuantity": 200,
                        "InvoicedQuantity": 200,
                        "IsClosed": true
                    }
                ]
            };
            showOrder(order);
        }

        function checkOrder(){
            const params = new URLSearchParams(window.location.search);
            var id = params.get('CustomerOrderReference');
            if(id != undefined){
                getOrder(id);
            }
        }

        function showOrder(order){
            var lines = [];
            $(order.Lines).each(function(i){
                lines.push(line.replaceAll('{title}', this.ProductName)
                                .replaceAll('{sku}', this.ProductCode)
                                .replaceAll('{unitPrice}', getPrice(this.UnitPrice))
                                .replaceAll('{quantity}', this.InvoicedQuantity)
                                .replaceAll('{price}', getPrice(this.InvoicedQuantity*this.UnitPrice)));
            });
            var m = modal.replaceAll('{name}', order.Header.CustomerOrderReference)
                        .replaceAll('{date}', order.Header.RegistrationDate)
                        .replaceAll('{payment_status}', getPayment(order.Header.InvoiceStatus))
                        .replaceAll('{fulfillment_status}', getFulfillment(order.Header.FulfillmentStatus))
                        .replaceAll('{shipping_address}', order.Header.ShippingAddress)
                        .replaceAll('{lines}', lines.join(''))
                        .replaceAll('{total}', getPrice(order.Header.Value));
            $('body').append(m);
            $('.btn-close').on('click', function(){
                $('.modal').remove();
                const params = new URLSearchParams(window.location.search);
                params.delete('CustomerOrderReference');
                window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            });
        }

        function getPayment(payment){
            return translations.payment_statuses[payment];
        }

        function getFulfillment(fulfillment){
            return translations.fulfillment_statuses[fulfillment];
        }

        function getPrice(price){
            return ('€'+price.toFixed(2)).replace('.', ',');
        }
    }
}

function setDashboard(){
    if($('[data-dashboard]').length){
        initDashboard($('[data-dashboard]').first());
    }

    function initDashboard(el){
        var data = [];
        getData();

        function getData(){
            var d = {
                "Elements": [
                    {
                        "Vendor": "Pirelli",
                        "ValueCurrentMonth": 12345.56,
                        "ValuePreviousMonth": 332345.56,
                        "ValueCurrentQuarter": 2323424.45,
                        "ValueCurrentYear": 2453454543.23,
                        "QuantityCurrentMonth": 12345,
                        "QuantityPreviousMonth": 1234,
                        "QuantityCurrentQuarter": 1234,
                        "QuantityCurrentYear": 2345556
                    },
                    {
                        "Vendor": "Continental",
                        "ValueCurrentMonth": 2345.56,
                        "ValuePreviousMonth": 232345.56,
                        "ValueCurrentQuarter": 3323424.45,
                        "ValueCurrentYear": 3453454543.23,
                        "QuantityCurrentMonth": 142345,
                        "QuantityPreviousMonth": 14234,
                        "QuantityCurrentQuarter": 12434,
                        "QuantityCurrentYear": 23445556
                    },
                    {
                        "Vendor": "Castrol",
                        "ValueCurrentMonth": 5345.56,
                        "ValuePreviousMonth": 532345.56,
                        "ValueCurrentQuarter": 5323424.45,
                        "ValueCurrentYear": 6453454543.23,
                        "QuantityCurrentMonth": 512345 + ' ' + 'Litri',
                        "QuantityPreviousMonth": 16234 + ' ' + 'Litri',
                        "QuantityCurrentQuarter": 5234 + ' ' + 'Litri',
                        "QuantityCurrentYear": 6345556 + ' ' + 'Litri'
                    }
                ]
            };
            data = d.Elements;
            showDashboard();
        }
    
        function showDashboard(){
            var boxes = [];
            $(data).each(function(){
                boxes.push(dashboard.replaceAll('{title}', this.Vendor)
                                    .replaceAll('{current_month}', this.QuantityCurrentMonth)
                                    .replaceAll('{previous_month}', this.QuantityPreviousMonth)
                                    .replaceAll('{current_quarter}', this.QuantityCurrentQuarter)
                                    .replaceAll('{current_year}', this.QuantityCurrentYear));
            });
            $(el).html(boxes.join(''));
        }
    }
}

function cartInput(){
    $('.cart-item-quantity-wrapper .quantity-input-minus').on('click',function(){
        $(this).parents('form').trigger('submit');
    });
    $('.cart-item-quantity-wrapper .quantity-input-plus').on('click',function(){
        $(this).parents('form').trigger('submit');
    });
    // $('.cart-item-quantity-wrapper .button-cart-remove').on('click',function(){
    //     $(this).parents('form').trigger('submit');
    // });
}

function minQty(){
    $('input[min]').on('blur', function(){
        try {
            var val = Number($(this).val());
            var min = Number($(this).attr('min'));
            if(val < min){
                $(this).val(min);
            }
        } catch {}
    });
}